module.exports = __webpack_public_path__ + "media/images/brand/photo03-34929bb363dff1784c494710aad18399.png";